import { getDefaultExportableFields } from "../js/utils";
import { ExportableField } from "./ExportableField";
import { useEffect, useState } from "react";

export function DashboardStorePanelFilterSectionExportableFields({
  typeId,
  type = "",
  exportableFields,
  onChange,
}) {
  const [selectedFields, setSelectedFields] = useState([]);

  const handleSelect = (id) => {
    setSelectedFields((prev) => [...new Set([...prev, id])]);
  };

  const handleDelete = (id) => {
    setSelectedFields((prev) => prev.filter((f) => f !== id));
  };

  const handleSelectAll = () => {
    if (typeId !== "")
      setSelectedFields(
        exportableFields
          .filter((e) => e.reportType.includes(typeId))
          .map((e) => e.id)
      );
  };

  const handleDeleteAll = () => {
    setSelectedFields([]);
  };

  useEffect(() => {
    if (type === 0) handleSelectAll();
  }, [type, typeId]);

  useEffect(() => {
    if (type === 1) {
      const defaultFields = getDefaultExportableFields(typeId);
      setSelectedFields([...defaultFields]);
    }
  }, [type, exportableFields, typeId]);

  useEffect(() => {
    onChange(selectedFields);
  }, [selectedFields]);

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <div className="opt-table-title opt-table-title-dash-stats">
          Campos exportables{" "}
          {type === 0
            ? "por tipo de informe"
            : type === 1
            ? "por tipo de familia"
            : ""}{" "}
          ({selectedFields.length}/
          {exportableFields.filter((e) => e.reportType.includes(typeId)).length}
          )
        </div>
        {typeId !== -1 && (
          <>
            <button
              className="cell-label"
              style={{ width: "150px" }}
              tabIndex={-1}
              onClick={handleSelectAll}
            >
              Seleccionar todo
            </button>
            <button
              className="cell-label"
              style={{ width: "150px" }}
              tabIndex={-1}
              onClick={handleDeleteAll}
            >
              Limpiar selección
            </button>
          </>
        )}
      </div>
      <div className="exportable-fields-container">
        {exportableFields.map((e) => {
          if (e.reportType.includes(typeId)) {
            return (
              <ExportableField
                key={e.id}
                data={e}
                selected={selectedFields.includes(e.id)}
                onSelect={handleSelect}
                onDelete={handleDelete}
              />
            );
          }
        })}
      </div>
    </div>
  );
}
